module.exports = __webpack_public_path__ + "img/screen_main_pic.1a16b43d.jpg";